<template>
    <div>
        <pc-label
            v-if="label"
            v-bind="labelBinder"
            v-on:help-clicked="$emit('help-clicked')" />
        <select
            v-bind="selectBinder"
            ref="input"
            v-model="internalValue"
            v-bind:required="required"
            v-bind:aria-invalid="hasValidationError"
            v-bind:aria-describedby="validationErrorId"
            class="form-select"
            no-interact
            v-on="listeners">
            <slot />
            <option
                v-for="(option, index) in options"
                v-bind:key="`option-${index}`"
                v-bind:value="option[valueProp]"
                v-bind:hidden="option[hiddenProp]">
                {{ option[textProp] }}
            </option>
            <optgroup
                v-for="(group, i) in optgroups"
                v-bind:key="`group-${i}`"
                v-bind:label="group.name"
                v-bind:class="{ 'text-danger': group.danger }">
                <option
                    v-for="(option, j) in group.options"
                    v-bind:key="`group-${i}-${j}`"
                    v-bind:value="option[valueProp]"
                    v-bind:hidden="option[hiddenProp]"
                    class="text-body">
                    {{ option[textProp] }}
                </option>
            </optgroup>
        </select>
        <div
            v-if="showValidationErrors"
            v-bind:id="validationErrorId"
            aria-live
            class="invalid-feedback fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";

    export default {
        extends: base,
        props: {
            modelValue: { type: [String, Number], required: false, default: null },
            options: { type: Array, required: false, default: null },
            optgroups: { type: Array, required: false, default: null },
            valueProp: { type: String, required: false, default: "value" },
            textProp: { type: String, required: false, default: "text" },
            hiddenProp: { type: String, required: false, default: "hidden" }
        },
        emits: ["help-clicked"],
        computed: {
            selectBinder() {
                const binder = this.binder;
                binder.disabled = binder.readonly || binder.disabled;
                return binder;
            }
        }
    };
</script>
